module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "approval container-flex"
  }, [_c('div', {
    staticClass: "panel panel-primary col-xs-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(!_vm.isDataLoaded) ? _c('loader', {
    staticClass: "panel-loader"
  }) : _vm._e(), _vm._v(" "), (_vm.isDataLoaded && _vm.hasError) ? _c('div', {
    staticClass: "error-container alert alert-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.error) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.hasResults) ? _c('div', {
    staticClass: "customer-search-results"
  }, [_c('sortable-table', {
    attrs: {
      "data": _vm.results,
      "columns": _vm.columns,
      "action": _vm.selectAction
    },
    on: {
      "action:select": _vm.select
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.hasResults) ? _c('div', {
    staticClass: "customer-search-no-results"
  }, [_vm._v("\n                0 requests found\n            ")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.hasSelected) ? _c('div', {
    staticClass: "panel panel-primary col-xs-4"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('h3', [_vm._v(_vm._s(_vm.selectedData.status) + " Request")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.selectedData.requestBy) + " to " + _vm._s(_vm.selectedData.assignedTo) + ":")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.selectedData.title))]), _vm._v(" "), _c('h3', [_vm._v("Notes")]), _vm._v(" "), _vm._l((_vm.selectedData.notes), function(note) {
    return _c('div', {
      staticClass: "note"
    }, [_c('div', [_c('span', {
      staticClass: "author"
    }, [_vm._v(_vm._s(note.by))]), _vm._v(" on "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(note.date))])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(note.body))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "pre col-xs-12",
    class: {
      'alert-danger': _vm.commentLength > _vm.maxCommentLength, 'alert-warning': _vm.commentLength < _vm.minCommentLength
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "character-counter",
    class: {
      'text-danger': _vm.commentLength > _vm.maxCommentLength
    }
  }, [(_vm.commentLength < _vm.minCommentLength) ? [_vm._v(_vm._s(_vm.minCommentLength - _vm.commentLength) + " character" + _vm._s(_vm.minCommentLength - _vm.commentLength != 1 ? 's' : '') + " too short")] : (_vm.commentLength <= _vm.maxCommentLength) ? [_vm._v(_vm._s(_vm.maxCommentLength - _vm.commentLength) + " character" + _vm._s(_vm.maxCommentLength - _vm.commentLength != 1 ? 's' : '') + " remaining")] : [_vm._v(_vm._s(_vm.commentLength - _vm.maxCommentLength) + " character" + _vm._s(_vm.commentLength - _vm.maxCommentLength != 1 ? 's' : '') + " too long")]], 2)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "search-action btn btn-danger col-xs-3 pull-right",
    attrs: {
      "disabled": _vm.commentLength < _vm.minCommentLength || _vm.commentLength > _vm.maxCommentLength
    },
    on: {
      "click": function($event) {
        _vm.reject()
      }
    }
  }, [_vm._v("Reject")]), _vm._v(" "), _c('button', {
    staticClass: "search-action btn btn-primary col-xs-3 pull-right",
    attrs: {
      "disabled": _vm.commentLength < _vm.minCommentLength || _vm.commentLength > _vm.maxCommentLength
    },
    on: {
      "click": function($event) {
        _vm.approve()
      }
    }
  }, [_vm._v("Approve")])])], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Approval Queue")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Approval")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "author"
  }, [_vm._v("Add a Comment")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf568d1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/ApprovalQueue.vue
// module id = 1118
// module chunks = 0